<template>
  <el-dialog :visible="visible" :title="$t('CargoMsg.Cargo_Prediction')" width="620px" custom-class="cargo-form-dialog" :close-on-click-modal="false" @close="handleClose">
    <el-form ref="form" label-width="100px" label-position="left" class="cargo-form">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.OperationCompany') }}：</span>
            <cargo-office-select
              :clearable="false"
              :have-hq="false"
              :disabled="isTrustFrom"
              no="opOffice"
              :office-id="Number(job.opOffice)"
              tag-name="code"
              tooltip
              @change="p=>{job.opOffice=p.value;officeChangeHandler(p)}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.Operation')+'：'">
            <cargo-user-select
              no="op"
              :method-params="{officeId:job.opOffice,category:'role',shape:'op'}"
              :default-value="job.op||''"
              @change="p=>{job.op=p.value;opChangeHandler(p)}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.OperationDepartment') }}：</span>
            <cargo-department-select
              no="opDepartment"
              :office-id="Number(job.opOffice) || $store.getters.currentOfficeId"
              :department-id="Number(job.opDepartment)"
              @change="p=>{job.opDepartment=p.value}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.CustomerService')+'：'">
            <cargo-user-select
              ref="csr"
              no="csr"
              :method-params="{officeId:(isTrustFrom || job.salesOffice===1)?job.opOffice:job.salesOffice,category:'role',shape:'csr'}"
              :default-value="job.csr||''"
              @change="p=>{job.csr=p.value;csrChangeHandler(p)}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.Documents')+'：'">
            <cargo-user-select
              ref="dc"
              no="dc"
              :method-params="{officeId:job.opOffice,category:'role',shape:'doc'}"
              :default-value="job.dc||''"
              @change="p=>{job.dc=p.value;dcChangeHandler(p)}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole1')+'：'">
            <cargo-user-select
              ref="userDefinedRoleId1"
              no="userDefinedRoleId1"
              :method-params="{officeId:job.opOffice,category:'role',shape:'userDefinedRole1'}"
              :default-value="job.userDefinedRoleId1||''"
              @change="p=>{job.userDefinedRoleId1=p.value;userDefinedRole1ChangeHandler(p)}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole2')+'：'">
            <cargo-user-select
              ref="userDefinedRoleId2"
              no="userDefinedRoleId2"
              :method-params="{officeId:job.opOffice,category:'role',shape:'userDefinedRole2'}"
              :default-value="job.userDefinedRoleId2||''"
              @change="p=>{job.userDefinedRoleId2=p.value;userDefinedRole2ChangeHandler(p)}"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" style="padding:10px;">
      <el-button type="primary" no="confirm" @click="handleSubmit">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button no="cancel" @click="handleClose">{{ $t('SeaExport.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import CargoForm from '@/components/Cargo/Common/CargoForm'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { Company } from '@/class/model/mdm/Company'
import { getSeaImportJobByUuid } from '@/api/SeaImport/seaImportJob'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'ForecastVerifyConfirmDialog',
  components: { cargoDepartmentSelect, cargoOfficeSelect, cargoUserSelect, cargoCompanySelect, CargoForm },
  props: {
    visible: { type: Boolean, default: () => false },
    jobModel: { type: Object, default: () => ({}) },
    submitCallBack: { type: Function, default: () => (null) }
  },
  data() {
    return {
      job: {
        op: 0,
        opOffice: 0,
        opDepartment: 0,
        csr: 0,
        dc: 0,
        userDefinedRoleId1: '',
        userDefinedRoleId2: ''
      },
      isTrustFrom: false,
      innerVisible: false,
      popperClass: '#E9650E',
      isAddUserDefinedRoles: false
    }
  },
  watch: {
    visible: {
      immediate: true,
      async handler(newVal) {
        if (newVal) {
          await this.init()
        }
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.isAddUserDefinedRoles = Number(cache.config.get('IsAddUserDefinedRoles')) === 1
  },
  methods: {
    async init() {
      Object.assign(this.job, this.jobModel)
      const dbJob = await getSeaImportJobByUuid(this.jobModel.uuid).then((res) =>
        res.data ? res.data : null
      )
      if (dbJob) Object.assign(this.job, dbJob)
      this.job.opOffice = this.job.opOffice || 1
      this.isTrustFrom = await this.checkTrustFrom()

      const deps = getCacheListByKey(basicCacheKeys.basic_data_Department)
      let officeId = ''
      if (this.job.opDepartment && this.job.opDepartment > 0 && deps && deps.length > 0) {
        let officeUuid = ''
        const dep = deps.find(p => p.departmentId === this.job.opDepartment)
        if (dep) officeUuid = dep.officeUuid
        if (officeUuid) {
          const officeList = getCacheListByKey(basicCacheKeys.basic_data_Office)
          const office = officeList.find(p => p.uuid === officeUuid)
          if (office) officeId = office.officeId
        }
      }
      if ((officeId && officeId !== this.job.opOffice)) {
        this.job.opDepartment = 0
      }
    },
    // 非委托单｛ job.salesOffice=当前分公司
    // and (job.trustFromJob is null or job.trustFromJob = '') and 委托单位不是内部公司)｝
    // 则客服跟销售公司，允许修改操作公司，否则委托单客服跟操作公司，不允许修改操作公司
    async checkTrustFrom() {
      const company = await Company.getCompanyById(this.job.customerId)
      const currentOfficeId = this.$store.getters.currentOfficeId
      if (this.job.salesChannel === 'B2B') { return false }
      if ((this.job.salesOffice && parseInt(this.job.salesOffice) === currentOfficeId && !this.job.trustFromJob && company && company.linkedBranchId === 0) || (this.job.salesOffice === 1)) {
        return false // 非委托单
      }
      return true
    },
    // 切换分公司
    officeChangeHandler() {
      if (!this.job.opOffice || this.job.opOffice <= 0) {
        this.job.opOffice = this.$store.getters.currentOfficeId
      }
    },
    // 选择操作时，获取操作分公司
    opChangeHandler(user) {
      if (user.defaultDepId > 0) {
        this.job.opDepartment = user.defaultDepId
      } else {
        if (this.job.opOffice > 0) {
          new User(user).getUserDefaultDepartmentByOffice('role', 'op', this.job.opOffice).then(dep => {
            this.job.opDepartment = dep ? dep.departmentId : 0
          })
        } else {
          new User(user).getDefaultDepartment('role', 'op', this.job.opOffice).then(dep => {
            this.job.opDepartment = dep ? dep.departmentId : 0
          })
        }
      }
    },
    // 客服改变
    async csrChangeHandler(data) {
      this.job.csr = data.value
      this.job.csrDepartment = 0
      this.job.csrOffice = 0
      if (data.value) {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'csr')
        if (dep) {
          this.job.csrDepartment = dep.departmentId
          const office = await Office.getOfficeByUuid(dep.officeUuid)
          this.job.csrOffice = office ? office.officeId : 0
        }
      }
    },
    // 单证改变
    async dcChangeHandler(data) {
      this.job.dc = data.value
      this.job.dcDepartment = 0
      this.job.dcOffice = 0
      if (data.value) {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'doc')
        this.job.dcDepartment = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        this.job.dcOffice = office ? office.officeId : 0
      } else {
        this.job.dc = 0
        this.job.dcDepartment = 0
        this.job.dcOffice = 0
      }
    },
    handleSubmit() {
      if ((!this.job.op || this.job.op <= 0) && this.job.salesChannel === 'JJCARGO') {
        this.$message.warning(this.$t('SeaExport.OperationCannotBeEmpty'))
        return
      }
      if (!this.job.opOffice || this.job.opOffice === 1 || this.job.opOffice <= 0) {
        this.$message.warning(this.$t('SeaExport.OperationCompanyCannotBeEmpty'))
        return
      }
      if (!this.job.opDepartment || this.job.opDepartment <= 0) {
        this.$message.warning(this.$t('SeaExport.OperationDepartmentCannotBeEmpty'))
        return
      }
      const form = {}
      form.opOffice = this.job.opOffice || 0
      form.op = this.job.op || 0
      if (this.job.opDepartment && this.job.opDepartment > 0) {
        form.opDepartment = this.job.opDepartment || 0
      }
      form.csr = this.job.csr || 0
      form.dc = this.job.dc || 0
      form.userDefinedRoleOffice1 = this.job.userDefinedRoleOffice1 || 0
      form.userDefinedRoleId1 = this.job.userDefinedRoleId1 || 0
      if (this.job.userDefinedRoleDept1 && this.job.userDefinedRoleDept1 > 0) {
        form.userDefinedRoleDept1 = this.job.userDefinedRoleDept1 || 0
      }
      form.userDefinedRoleOffice2 = this.job.userDefinedRoleOffice2 || 0
      form.userDefinedRoleId2 = this.job.userDefinedRoleId2 || 0
      if (this.job.userDefinedRoleDept2 && this.job.userDefinedRoleDept2 > 0) {
        form.userDefinedRoleDept2 = this.job.userDefinedRoleDept2 || 0
      }
      this.submitCallBack(form)
      this.handleClose()
    },
    handleClose() {
      this.$emit('closePageHandler')
    },
    // 自定义岗位1
    async userDefinedRole1ChangeHandler(data) {
      this.job.userDefinedRoleId1 = data.value
      this.job.userDefinedRoleDept1 = 0
      this.job.userDefinedRoleOffice1 = 0
      if (data.value) {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole1')
        this.job.userDefinedRoleDept1 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        this.job.userDefinedRoleOffice1 = office ? office.officeId : 0
      } else {
        this.job.userDefinedRoleId1 = 0
        this.job.userDefinedRoleDept1 = 0
        this.job.userDefinedRoleOffice1 = 0
      }
    },
    // 自定义岗位2
    async userDefinedRole2ChangeHandler(data) {
      this.job.userDefinedRoleId2 = data.value
      this.job.userDefinedRoleDept2 = 0
      this.job.userDefinedRoleOffice2 = 0
      if (data.value) {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole2')
        this.job.userDefinedRoleDept2 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        this.job.userDefinedRoleOffice2 = office ? office.officeId : 0
      } else {
        this.job.userDefinedRoleId2 = 0
        this.job.userDefinedRoleDept2 = 0
        this.job.userDefinedRoleOffice2 = 0
      }
    }
  }
}
</script>
<style lang="scss">
  .cargo-form-dialog{
    .el-dialog{
      &__header,&__body,&__footer{
        padding:10px 15px!important;
      }
      &__title{
        vertical-align: middle;
      }
      &__headerbtn{
        top:15px;
        right:15px;
      }
    }
  }
  .cargo-form{
    .el-form-item {
      &.red-input{
        .el-input__inner{
          color: #E9650E;
        }
      }
      &__content{
        width: auto!important;
      }
      &.label-none {
        .el-form-item__content{
          margin-left: 0;
        }
      }
    }
  }
</style>
